module.exports = __webpack_public_path__ + "static/application_suffer-479c7e2fbe41afdcc3e0ee2dd745c501.webp";